module.exports = __webpack_public_path__ + "img/undraw_page_not_found_re_e9o6.6c8dd5cc.svg";